export default __webpack_public_path__ + "static/Asset7@2x-b55221f73f0d8481935da1ca5d7d1243.png";